export default
    [{
        path: '/',
        component: require('./components/Dashboard.vue').default,
        meta: { menu: 'konsultant' }
    },
    {
        path: '/nadpis/add',
        component: require('./components/nadpis/NadpisEdit.vue').default,
        meta: { menu: 'nadpis' }
    },
    {
        path: '/nadpis',
        component: require('./components/nadpis/NadpisIndex.vue').default,
        meta: { menu: 'nadpis' }
    },
    {
        path: '/client',
        component: require('./components/client/ClientIndex.vue').default,
        meta: { menu: 'client' }
    },

    {
        path: '/client/:id/sms',
        component: require('./components/client/ClientSms.vue').default,
        meta: { menu: 'client' }
    },
    {
        path: '/sms',
        component: require('./components/sms/SmsIndex.vue').default,
        meta: { menu: 'sms' }
    },
    {
        path: '/settings',
        component: require('./components/Settings.vue').default,
        meta: { menu: 'settings' }
    },
    {
        path: '*',
        component: require('./components/NotFound.vue').default,
        meta: { menu: '' }
    }];